import React, { useEffect, useState } from 'react';
import { ProButton } from '../../../../../atoms/Button/ProButton';
import { ProIconData, ProIconTypeData } from '../../../../../atoms/Icons/IconData';
import { ProFilterPopup } from '../../../../../atoms/ProFilterPopup/ProFilterPopup';
import { ProIntent } from '../../../../../utils/enums';
import { Components } from '../../../../../utils/types';

export const usePlanningFilter = (refinedData: Components.Schemas.WBSElementDeltaDTO[]) => {
    const [filter, setFilter] = useState<string[]>([]);
    const [search, setSearch] = useState<string>();
    const [filteredData, setFilteredData] = useState<Components.Schemas.WBSElementDeltaDTO[]>(refinedData);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const res = refinedData
            .filter((cur) => !filter?.includes(cur.wbsCompletionState?.completionStateType ?? 'undefined'))
            .filter((akt) => !filter?.includes(akt.wbsElementType ?? 'undefined'));
        setFilteredData(filter ? res : refinedData);
    }, [refinedData, filter]);

    const addOrRemoveFromFilter = (item: string) => {
        if (filter?.includes(item)) setFilter(filter.filter((cur) => cur !== item));
        else setFilter((cur) => (cur ? [...cur, item] : [item]));
    };

    const render = () => (
        <ProFilterPopup isOpen={isOpen} setIsOpen={setIsOpen} isActive={filter.length > 0}>
            <h4>By schedule</h4>
            <div>
                <ProButton
                    text="Not Started"
                    onClick={() => addOrRemoveFromFilter('NotStarted')}
                    mainIntent={filter?.includes('NotStarted') ? ProIntent.Gray : ProIntent.Primary}
                    className="ProButtonRow--first"
                    placement="bottom"
                />
                <ProButton
                    text="In Progress"
                    onClick={() => addOrRemoveFromFilter('InProgress')}
                    mainIntent={filter?.includes('InProgress') ? ProIntent.Gray : ProIntent.Primary}
                    placement="bottom"
                />
                <ProButton
                    text="Finished"
                    onClick={() => addOrRemoveFromFilter('Finished')}
                    mainIntent={filter?.includes('Finished') ? ProIntent.Gray : ProIntent.Primary}
                    placement="bottom"
                />
            </div>
            <h4>By type</h4>
            <div>
                <ProButton
                    text="Sprint"
                    leftIcon={ProIconTypeData.Sprint}
                    onClick={() => addOrRemoveFromFilter('Sprint')}
                    mainIntent={filter?.includes('Sprint') ? ProIntent.Gray : ProIntent.Primary}
                    className="ProButtonRow--first"
                    placement="bottom"
                />
                <ProButton
                    text="Workpackage"
                    leftIcon={ProIconData.package_fill}
                    onClick={() => addOrRemoveFromFilter('WorkPackage')}
                    mainIntent={filter?.includes('WorkPackage') ? ProIntent.Gray : ProIntent.Primary}
                    placement="bottom"
                />
            </div>
        </ProFilterPopup>
    );
    return { filter, search, render, filteredData };
};
